import { action, observable } from "mobx";
import { api } from "../../api";
import { api_adm } from "../../api";
import { ICnae } from "../../model";
import { toast } from "react-toastify";

export class _CnaeStore {
  obs = observable({
    cnae: []  as ICnae[],
    viewResposta: false  as boolean,
    lengthProduto: 0  as number,
    status200: false  as boolean,
    loading: false as boolean,
  })

  constructor() {
  }

  @action
  async cnaeLoad(index: number): Promise<void> {
    try {
      this.obs.loading = true;
      let resp = await api.get(`/api/cnae-list/${index}`);

        this.obs.cnae = [];
        this.obs.lengthProduto = resp.data.total;
        this.obs.cnae = resp.data.itens;
        this.obs.loading = false;
    } catch (ex) {
      this.obs.loading = false
      toast.error("Erro ao carregar Cnae, tente novamente mais tarde.", {});
    }
  }

  async updateAtividade(data) {
    try {
      this.obs.status200 = false;

      let resp = await api_adm.post("/api/admin/update-atividade", data);

      if (resp.data === "ok") {
        this.obs.status200 = true;
      }
    } catch (ex) {
      toast.error("Erro ao atualizar atividade cnae, tente novamente mais tarde.", {});
    }
  }
}

export const CnaeStore = new _CnaeStore();
